import { useEffect, useState } from 'react'

import { FC, invalidateQuery, useCQuery } from '../../../../Services'
import { showToast } from '../../../../utils/toast'

export const useTraveller = (travellerId) => {
  const [traveller, setTraveller] = useState()
  const { data, isSuccess } = useCQuery(['traveller', travellerId])

  useEffect(() => {
    isSuccess && setTraveller(data)
  }, [isSuccess, data])

  const setTravellerProp = (prop, value) => setTraveller({ ...traveller, [prop]: value })

  return [traveller, setTravellerProp, isSuccess]
}

export const saveTraveller = async (traveller) => {
  try {
    if (traveller.id === 'new') {
      delete traveller.id
      const res = await FC.service('travellers').create(traveller)
      invalidateQuery(['traveller', 'travellers'])
      showToast('success', 'Success', 'Salvataggio effettuato')
      return res
    }
    const res = await FC.service('travellers').patch(traveller.id, traveller)
    invalidateQuery(['traveller', 'travellers'])
    showToast('success', 'Success', 'Salvataggio effettuato')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Errore durante il salvataggio')
    return false
  }
}

export const deleteTraveller = async (travellerId) => {
  try {
    const res = await FC.service('travellers').remove(travellerId)
    invalidateQuery(['traveller', 'travellers'])
    showToast('success', 'Success', 'Eliminazione effettuata')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || "Errore durante l'eliminazione")
    return false
  }
}
